<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      directives: [
        {
          name: "b-tooltip",
          rawName: "v-b-tooltip.hover.v-primary",
          modifiers: { hover: true, "v-primary": true },
        },
      ],
      staticClass: "primaryColor pointer padding-rg",
      attrs: {
        title: _vm.$t("feedback.back"),
        variant: "primary",
        rounded: "",
      },
      on: { click: _vm.back },
    },
    [_c("Back")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/layouts/components/BackButton.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
import assets_rashi_coin_back_arrow_svg from '@/assets/rashi-coin/back-arrow.svg';
//
//
//
//
//
//
//
//
//
//
//
//
//



export default ({
  render,
  staticRenderFns,
  components: {
    BButton: bootstrapvue["BButton"],
    Back: assets_rashi_coin_back_arrow_svg
  },
  directives: {
    "b-tooltip": bootstrapvue["VBTooltip"]
  },
  data() {
    return {};
  },
  methods: {
    back() {
      this.$router.go(-1);
    }
  },
  props: {}
});

//# sourceURL=webpack:///./src/layouts/components/BackButton.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style scoped>
.primaryColor {
  color: var(--primary);
}
[dir=ltr] .padding-rg {
  padding: 2px 10px 2px 0;
}
[dir=rtl] .padding-rg {
  padding: 2px 0 2px 10px;
}
.primaryColor {
  color: var(--primary);
}
[dir=ltr] .padding-rg {
  padding: 2px 10px 2px 0;
}
[dir=rtl] .padding-rg {
  padding: 2px 0 2px 10px;
}
.primaryColor {
  color: var(--primary);
}
[dir=ltr] .padding-rg {
  padding: 2px 10px 2px 0;
}
[dir=rtl] .padding-rg {
  padding: 2px 0 2px 10px;
}
.primaryColor {
  color: var(--primary);
}
[dir=ltr] .padding-rg {
  padding: 2px 10px 2px 0;
}
[dir=rtl] .padding-rg {
  padding: 2px 0 2px 10px;
}
.primaryColor {
  color: var(--primary);
}
[dir=ltr] .padding-rg {
  padding: 2px 10px 2px 0;
}
[dir=rtl] .padding-rg {
  padding: 2px 0 2px 10px;
}
</style>
